import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-pause', 'IconClockPause', [
  ['path', { d: 'M20.942 13.018a9 9 0 1 0 -7.909 7.922', key: 'svg-0' }],
  ['path', { d: 'M12 7v5l2 2', key: 'svg-1' }],
  ['path', { d: 'M17 17v5', key: 'svg-2' }],
  ['path', { d: 'M21 17v5', key: 'svg-3' }],
]);
